'use strict';

module.exports = {
    isDesktop: function () {
        return window.matchMedia('(min-width: 769px)').matches;
    }
};
